import React from "react";
import moment from "moment";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import AsyncSelect from "react-select/lib/Async";

// Filtros comunes a los reportes de producción. El padre PT siempre es
// obligatorio, porque define los almacenes que se consideran; el rango de
// fechas lo es salvo que la pantalla lo declare opcional
export const FiltrosReporteProduccion = ({ hook }) => {
    const {
        formControl,
        formErrors,
        loadPadresProductoTerminado,
        consultarReporte,
        limpiarConsulta,
        cargando,
    } = hook;

    const reglasFecha = (mensaje) => ({ required: mensaje });

    // el reporte que indica limpiarConsulta quita lo consultado en cuanto cambia
    // un filtro, porque ya no le corresponde; los demás lo conservan hasta volver
    // a filtrar
    const cambiarFiltro = (field, valor) => {
        field.onChange(valor);

        if (limpiarConsulta) {
            limpiarConsulta();
        }
    };

    const fechaInicial = formControl._formValues.fecha_inicial;
    const fechaFinal = formControl._formValues.fecha_final;

    return (
        <div className="formulario-fields-row my-0">
            <div className="formulario-field min-w-150">
                <label htmlFor="fecha_inicial" className="m-0 text-nowrap">
                    Fecha inicial
                </label>
                <Controller
                    name="fecha_inicial"
                    control={formControl}
                    rules={reglasFecha("Seleccione la fecha inicial")}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => cambiarFiltro(field, date)}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha inicial"
                            maxDate={fechaFinal || moment()}
                        />
                    )}
                />
                {formErrors.fecha_inicial && (
                    <small className="text-danger">
                        {formErrors.fecha_inicial.message}
                    </small>
                )}
            </div>

            <div className="formulario-field min-w-150">
                <label htmlFor="fecha_final" className="m-0 text-nowrap">
                    Fecha final
                </label>
                <Controller
                    name="fecha_final"
                    control={formControl}
                    rules={reglasFecha("Seleccione la fecha final")}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => cambiarFiltro(field, date)}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha final"
                            minDate={fechaInicial || undefined}
                        />
                    )}
                />
                {formErrors.fecha_final && (
                    <small className="text-danger">
                        {formErrors.fecha_final.message}
                    </small>
                )}
            </div>

            <div className="formulario-field" style={{ minWidth: "220px" }}>
                <label
                    htmlFor="padre_producto_terminado"
                    className="m-0 text-nowrap"
                >
                    Producto padre
                </label>
                <Controller
                    name="padre_producto_terminado"
                    control={formControl}
                    rules={{ required: "Seleccione el producto padre" }}
                    render={({ field }) => (
                        <AsyncSelect
                            {...field}
                            className="react-select-container"
                            isSearchable
                            isClearable
                            cacheOptions
                            defaultOptions
                            loadOptions={loadPadresProductoTerminado}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.nombre}
                            placeholder="Seleccionar"
                            onChange={(selected) =>
                                cambiarFiltro(field, selected)
                            }
                        />
                    )}
                />
                {formErrors.padre_producto_terminado && (
                    <small className="text-danger">
                        {formErrors.padre_producto_terminado.message}
                    </small>
                )}
            </div>

            <div
                className="formulario-field mb-0 no-flex"
                style={{ maxHeight: "51px" }}
            >
                <button
                    className="btn btn-primary mt-auto"
                    onClick={consultarReporte}
                    disabled={cargando}
                >
                    Filtrar
                </button>
            </div>
        </div>
    );
};
